import type {TriggerIntegrationSpec, TriggerIntegrationStruct} from '@cohort/shared/apps/trigger';
import {LocalizedStringSchema} from '@cohort/shared/schema/common';
import {z} from 'zod';

const BottomActionLabelSchema = LocalizedStringSchema;
export const CohortSwipeCardsTriggerConfigSchema = z.object({
  leftBtnLabel: BottomActionLabelSchema,
  rightBtnLabel: BottomActionLabelSchema,
  cards: z
    .array(
      z.object({
        id: z.string().uuid(),
        title: LocalizedStringSchema.optional(),
        imageFileKey: z.string(),
      })
    )
    .min(1),
  // start deprecated
  title: LocalizedStringSchema.optional(),
  actionCtaLabel: LocalizedStringSchema.optional(),
  // end deprecated
});
export type CohortSwipeCardsTriggerConfig = z.infer<typeof CohortSwipeCardsTriggerConfigSchema>;

const CohortSwipeCardsTriggerAnswerDataSchema = z.object({
  cardId: z.string().uuid(),
  cardTitle: z.string().optional(),
  cardImageFileKey: z.string(),
  answer: z.string(),
});

export const CohortSwipeCardsVerificationAttemptInputSchema = z.object({
  answers: z.record(z.string().uuid(), CohortSwipeCardsTriggerAnswerDataSchema),
});
export type CohortSwipeCardsVerificationAttemptInput = z.infer<
  typeof CohortSwipeCardsVerificationAttemptInputSchema
>;

export const ExposedCohortSwipeCardsTriggerAnswerDataSchema =
  CohortSwipeCardsTriggerAnswerDataSchema;
export type ExposedCohortSwipeCardsTriggerAnswerData = z.infer<
  typeof ExposedCohortSwipeCardsTriggerAnswerDataSchema
>;

export const CohortSwipeCardsVerificationAttemptDataSchema = z.object({
  answers: z.record(z.string().uuid(), ExposedCohortSwipeCardsTriggerAnswerDataSchema),
});
export type CohortSwipeCardsVerificationAttemptData = z.infer<
  typeof CohortSwipeCardsVerificationAttemptDataSchema
>;

const CohortSwipeCardsSocialLayerDataSchema = z.object({
  cards: z.record(
    z.string().uuid(),
    z.object({
      left: z.number(),
      right: z.number(),
    })
  ),
});
type CohortSwipeCardsSocialLayerData = z.infer<typeof CohortSwipeCardsSocialLayerDataSchema>;

export type CohortSwipeCardsTriggerStruct = TriggerIntegrationStruct<
  'cohort-form.swipe-cards',
  CohortSwipeCardsTriggerConfig,
  CohortSwipeCardsVerificationAttemptData,
  CohortSwipeCardsVerificationAttemptInput,
  CohortSwipeCardsSocialLayerData
>;

export const CohortSwipeCardsTriggerIntegrationSpec: TriggerIntegrationSpec<CohortSwipeCardsTriggerStruct> =
  {
    id: 'cohort-form.swipe-cards' as const,
    configurableMaxAttempts: false,
    configSchema: CohortSwipeCardsTriggerConfigSchema,
    verificationAttemptDataSchema: CohortSwipeCardsVerificationAttemptDataSchema,
    verificationAttemptInputSchema: CohortSwipeCardsVerificationAttemptInputSchema,
    socialLayerDataSchema: CohortSwipeCardsSocialLayerDataSchema,
    requiresMerchantConnection: false,
    useCases: ['customer-knowledge'],
  };
